<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
    <el-date-picker
      v-model="dataTime"
      type="daterange"
      value-format='yyyy-MM-dd'
      style="margin-right: 10px"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        @click="select()"
        >筛选</el-button
      >
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 3981px"
      size="mini"
    >
      <el-table-column prop="date" label="日期" width="100">
        <template slot-scope="scope">{{ happenTimeFun(scope.row.date) == '9999-01-01'?'汇总':happenTimeFun(scope.row.date)}}</template>
      </el-table-column>
      <el-table-column prop="registerCount" label="注册人数" width="100" />
      <el-table-column prop="rechargeCount" label="充值人数" width="100" />
      <el-table-column prop="withdrawCount" label="提现人数" width="100" />
      <el-table-column prop="rechargeSum" label="充值USDT" width="100" />
      <el-table-column prop="withdrawSum" label="提现USDT" width="150" />
      <el-table-column prop="rechargeSumTrx" label="充值TRX" width="100" />
      <el-table-column prop="rechargeSumUsdc" label="充值USDC" width="130" />
      <el-table-column prop="rechargeSumBtc" label="充值BTC" width="100" />
      <el-table-column prop="rechargeSumEth" label="充值ETH" width="100" />
      <el-table-column prop="rechargeSumPol" label="充值POL" width="130" />
      <el-table-column prop="rechargeSumDai" label="充值DAI" width="130" />
      <el-table-column prop="withdrawChargeSum" label="提现手续费USDT" width="100" />
      <el-table-column prop="totalAmount" label="总余额USDT" width="110" />
      <el-table-column prop="totalTeamAmount" label="团队余额" width="100" />
      <el-table-column prop="totalTeamProfit" label="团队收益" width="100" />
      <!-- <el-table-column prop="airdropTotalRealAmount" label="总AI余额" width="100" />
      <el-table-column prop="airdropTotalWaitAmount" label="解锁中ai余额" width="120" /> -->
      <el-table-column label="签到">
        <template slot="header">
          <div style="background-color: #C4FF65; color: #000;">签到统计</div>
        </template>
        <el-table-column prop="signInTotalAmount" label="签到金额" width="100" />
        <el-table-column prop="signInTotalCount" label="签到账号数" width="100" />
      </el-table-column>
      <el-table-column label="">
        <template slot="header">
          <div style="background-color: #80FFA4; color: #000;">发帖</div>
        </template>
        <el-table-column prop="postCount" label="提交账号数" width="100" />
        <el-table-column prop="postReceiveCount" label="领取账号数" width="100" />
        <el-table-column prop="postReceiveAmount" label="领取金额" width="100" />
      </el-table-column>
      <el-table-column label="抽奖">
        <template slot="header">
          <div style="background-color: #FFFF80; color: #000;">拉新</div>
        </template>
        <el-table-column prop="paaCount" label="参与账号数" width="100" />
        <el-table-column prop="paaReceiveAmount" label="领取金额" width="100" />
      </el-table-column>
      <el-table-column label="抽奖">
        <template slot="header">
          <div style="background-color: #FAE6FF; color: #000;">抽奖</div>
        </template>
        <el-table-column prop="drawTotalAmount" label="领取奖励金额" width="110" />
        <el-table-column prop="drawTotalCount" label="领取奖励账号" width="110" />
        <el-table-column prop="drawTotalCount2" label="抽奖账号数" width="110" />
      </el-table-column>
      <el-table-column label="抽奖">
        <template slot="header">
          <div style="background-color: #D9ECF6; color: #000;">AI机器人</div>
        </template>
        <el-table-column prop="airdropBuyCount" label="购买人数" width="100" />
        <el-table-column prop="airdropBuyAmount" label="购买金额" width="100" />
        <el-table-column prop="airdropReceiveCount" label="领取人数" width="100" />
        <el-table-column prop="airdropReceiveAmount" label="领取收益" width="100" />
        <el-table-column prop="airdropProfitAmount" label="收益分佣" width="100" />

        <el-table-column prop="airdropChallenge1" label="挑战支出" width="100" />
        <el-table-column prop="airdropChallenge2" label="挑战收入" width="100" />
        <el-table-column prop="airdropCount1" label="No.1" width="100" />
        <el-table-column prop="airdropCount2" label="No.2" width="100" />
        <el-table-column prop="airdropCount3" label="No.3" width="100" />
        <el-table-column prop="airdropCount4" label="No.4" width="100" />
        <el-table-column prop="airdropCount5" label="No.6" width="100" />
        <el-table-column prop="airdropCount6" label="No.9" width="100" />
        <el-table-column prop="airdropCount7" label="No.12" width="100" />
      </el-table-column>
      <el-table-column label="CM等级">
        <template slot="header">
          <div style="background-color: #DBFFA0; color: #000;">CM等级</div>
        </template>
        <el-table-column prop="cm1" label="1级" width="100" />
        <el-table-column prop="cm2" label="2级" width="100" />
        <el-table-column prop="cm3" label="3级" width="100" />
        <el-table-column prop="cm4" label="4级" width="100" />
        <el-table-column prop="cm5" label="5级" width="100" />
      </el-table-column>
      <el-table-column label="抽奖">
        <template slot="header">
          <div style="background-color: #FACE91; color: #000;">投资</div>
        </template>
        <el-table-column prop="investTotalAmount" label="投资金额总和" width="120">
          <template slot="header">
          <div>
            <div>投资金额总和</div>
            <div>(可出售金额)</div>
          </div>
        </template>
        </el-table-column>
        <el-table-column prop="investTotalBuy" label="今日投资金额" width="110" />
        <el-table-column prop="investTotalSale" label="今日出售金额" width="110" />
      </el-table-column>
      <el-table-column label="P2P交易">
        <template slot="header">
          <div style="background-color: #70F1C1; color: #000;">P2P交易</div>
        </template>
        <el-table-column prop="ccSaleMemberCount" label="在售用户" width="110" />
        <el-table-column prop="ccSaleMachineCount" label="在售矿机数量" width="110" />
        <el-table-column prop="ccSaleCount" label="已出售次数" width="110" />
        <el-table-column prop="ccBuybackCount" label="回购次数" width="110" />
        <el-table-column prop="ccSaleAmount" label="在售金额" width="110" />
        <el-table-column prop="ccSoldAmount" label="已出售金额" width="110" />
        <el-table-column prop="ccBuybackAmount" label="回购金额" width="110" />
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加载
      dataTime:['',''],
      startDate:'',
      endDate:''
    };
  },
  created(){
    let time = +new Date()
    let time1 = +new Date()-7*24*60*60*1000
    this.dataTime[0] = this.happenTimeFun(time1)
    this.dataTime[1] = this.happenTimeFun(time)
    console.log(this.dataTime)
  },
  mounted() {
    this.getRoleinfo();
  },
  methods: {
    happenTimeFun(num){
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d
},
    // 筛选
    select() {
      this.pageNum = 1;
      this.getRoleinfo();
    },
    // 获取表单信息
    getRoleinfo() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        startDate: this.dataTime[0],
        endDate:this.dataTime[1]
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.administrator
        .dataList(params)
        .then((res) => {
          this.tableData = res;
          // this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table tr:first-child{
  background-color: #d9ffe6 !important;
}
// ::v-deep .el-table_1_column_13{
//   background-color: #FACD91 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_18{
//   background-color: #00FFB4 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_23{
//   background-color: #80FFFF !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_32{
//   background-color: #C4FF65 !important;
//   color: #000 !important;
// }
// ::v-deep .el-table_1_column_35{
//   background-color: #FAE6FF !important;
//   color: #000 !important;
// }
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}

</style>
